interface ISearchParams {
	[key: string]: string;
}

export const parseUrlFilters = (route: string, params: ISearchParams) => {
	const queryParams = new URLSearchParams(params);

	return `${route}?${queryParams}`;
};
